import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../../assets/logo.png'; // Asegúrate de que la ruta sea correcta
import { useAuth } from '../../metodos/AuthContext';

const RecuperarContrasena = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [successMessage, setSuccessMessage] = useState(null)

    const navigate = useNavigate();

    const { resetPassword } = useAuth();
    

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        setSuccessMessage(null);

        try{
          await resetPassword(email);
          setSuccessMessage('Te hemos enviado un correo con instrucciones para recuperar tu contraseña, verifica tu correos no deseados por si acaso');
        }
        catch(error){
          console.error("Error al recuperar contraseña:", error);
          console.log("Error ",error);
        }
        finally{
          setLoading(false);
        }

      };

    const handleBackToLogin = () => {
        navigate('/login');
      };


    return (
        <div className="login-container">
          <div className="login-card">
            <div className="login-logo">
              <img src={logo} alt="Logo de la aplicación" />
            </div>
            
            <h2>Recuperar Contraseña</h2>
            
            {error && <div className="error-message">{error}</div>}
            {successMessage && <div className="success-message">{successMessage}</div>}
            
            {!successMessage ? (
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="email">Correo electrónico</label>
                  <p className="form-description">
                    Ingresa tu correo electrónico y te enviaremos las instrucciones para restablecer tu contraseña.
                  </p>
                  <input
                    type="email"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="ejemplo@correo.com"
                    required
                  />
                </div>
                
                <button
                  type="submit"
                  className="login-button"
                  disabled={loading}
                >
                  {loading ? 'Enviando...' : 'Recuperar Contraseña'}
                </button>
              </form>
            ) : (
              <button
                onClick={handleBackToLogin}
                className="login-button"
                type="button"
              >
                Volver a Iniciar Sesión
              </button>
            )}
            
            <button 
              onClick={handleBackToLogin} 
              className="team-link" 
              type="button"
            >
              Volver
            </button>
            
            <div className="version-container">
              <span className="version">v1.8.6</span>
            </div>
          </div>
        </div>
      );
}

export default RecuperarContrasena
